'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');

var PasswordResetView = AbstractFormView.extend({
    template: require('components/activation/templates/password_reset'),

    controller: undefined,

    events: {
        'click button.js-set': 'setClicked',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.token = options.token || '';

        AbstractFormView.prototype.initialize.apply(this, [
            {
                errors: options.errors,
                inputFields: {
                    'js-password': {
                        decoIcon: 'glyphicon glyphicon-ok',
                        method: 'password',
                    },
                },
            },
        ]);
    },

    setClicked: function (e) {
        e.preventDefault();
        if (this.allFieldsValid()) {
            this.controller.doPasswordReset({
                token: this.token,
                formData: Backbone.Syphon.serialize(this),
            });
        }
    },
});

module.exports = PasswordResetView;
